var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 3.28125L11.7188 0.9375L2.34375 10.3125L1.40625 13.5938L4.6875 12.6562L14.0625 3.28125ZM9.84375 2.8125L12.1875 5.15625L9.84375 2.8125ZM2.34375 10.3125L4.6875 12.6562L2.34375 10.3125Z",
    stroke: "#396FC9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil_icon.5926abd61d195d77ee06f0228f7663dc.svg";
export { ForwardRef as ReactComponent };